import { CashinClosingState } from 'nike-ui/src/types/cashin-closing';
import { useCashinClosingDialog } from '@/cashins/views/popup/useCashinClosingDialog';
import i18n from '@i18n';
import Dialog, { DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';
import React, { useEffect } from 'react';
import { fromJS } from 'immutable';
import { Button } from 'nike-ui/src/components/button/Button';
import { closeCashinDialog } from '@/cashins/handlers';
import { dispatch } from 'nike-re-framejs';
import { clearCashinClosingMode } from 'nike-ui/src/components/ticketus/handlers';

const ClosingCashinDialog = ({ ticketId }) => {
    const { offer, state } = useCashinClosingDialog(ticketId);

    if (!offer) {
        return null;
    }

    return (
        <Dialog modal>
            <CashinPopupState state={state} offer={fromJS(offer)} />
        </Dialog>
    );
};

const CashinPopupState = ({ state, offer }) => {
    useEffect(() => {
        if (state === CashinClosingState.RESULT) {
            dispatch(clearCashinClosingMode);
        }
    }, [state]);

    switch (state) {
        case CashinClosingState.RESULT:
            return (
                <CashinClosingPopupState
                    msg={i18n('ticketus.cashin.closing.status.success')}
                    offer={offer}
                    dataAtid={'cashin-closing-success'}
                />
            );
        case CashinClosingState.IN_PROGRESS:
            return <InProgress />;
        case CashinClosingState.ERROR:
            return (
                <CashinClosingPopupState
                    msg={i18n('ticketus.cashin.closing.status.error')}
                    offer={offer}
                    dataAtid={'cashin-closing-fail'}
                />
            );
        default:
            return (
                <CashinClosingPopupState
                    msg={i18n('ticketus.cashin.closing.status.not-available')}
                    offer={offer}
                    dataAtid={'cashin-closing-fail'}
                />
            );
    }
};

const InProgress = () => {
    return (
        <>
            <DialogBody>
                <div className="ajax-preloader" />
                <div className="cashin-waiting">{i18n('ticketus.cashin.wait')}</div>
            </DialogBody>
        </>
    );
};

const closeDialog = ({ offer, message }) => {
    dispatch(closeCashinDialog({ offer, message }));
};
const CashinClosingPopupState = ({ msg, offer, dataAtid }) => {
    return (
        <>
            <DialogTitle>
                <p>{msg}</p>
            </DialogTitle>
            <DialogBody>
                <div className="flex-center justify-around">
                    <Button
                        className="nui-button-180 nui-button-center"
                        primary
                        label={i18n('cashin.term.close')}
                        onClick={() => closeDialog({ offer, message: msg })}
                        dataAtid={dataAtid}
                    />
                </div>
            </DialogBody>
        </>
    );
};

export default ClosingCashinDialog;
